import { render, staticRenderFns } from "./judge.vue?vue&type=template&id=39a1cdb2&scoped=true&"
import script from "./judge.vue?vue&type=script&lang=js&"
export * from "./judge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1cdb2",
  null
  
)

export default component.exports